import React from "react"
import * as styles from "./Styles/ShareButtons.module.scss"

const Buttons = () => {
  const url = location.toString()

  return (
    <React.Fragment>
      <div className={styles.header}>
        家族や身近な人にこのページをシェアしよう
      </div>
      <div className={styles.buttons}>
        <a
          href="https://twitter.com/intent/tweet"
          className="twitter-share-button"
          data-url={url}
          data-lang="ja"
          data-show-count="false"
          data-size="large"
        >
          ツイート
        </a>
        <iframe
          src={`https://www.facebook.com/plugins/share_button.php?href=${url}&layout=button&size=large&appId=251342944892355&width=79&height=28`}
          width="79"
          height="28"
          style={{ border: 0, overflow: "hidden" }}
          scrolling="no"
          frameBorder="0"
          allow="encrypted-media"
        ></iframe>
        <div
          className="line-it-button"
          data-lang="ja"
          data-type="share-a"
          data-ver="3"
          data-url={url}
          data-color="default"
          data-size="large"
          data-count="false"
          style={{ display: "none" }}
        ></div>
      </div>
    </React.Fragment>
  )
}
export default Buttons
